import FeatherIcon from "./FeatherIcon";

// Restore focus by stable identity, including editors that remount their cards.
export const keepReorderInView = (id, direction) => {
  requestAnimationFrame(() => {
    const group = Array.from(document.querySelectorAll("[data-reorder-id]"))
      .find((element) => element.dataset.reorderId === String(id));
    if (!group) return;
    const button = group.querySelector(`[data-direction="${direction}"]:not(:disabled)`)
      || group.querySelector("button:not(:disabled)");
    button?.focus({ preventScroll: true });
    group.scrollIntoView?.({ block: "nearest", inline: "nearest" });
  });
};

export default function ReorderControls({ id, index, count, onMove, disabled = false, noun = "item" }) {
  return (
    <div data-reorder-id={id} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      {[-1, 1].map((offset) => {
        const direction = offset < 0 ? "up" : "down";
        const label = `Move ${noun} ${direction}`;
        return <button key={direction} type="button" className="uk-button hms-simple-icon-btn"
          style={{ minWidth: 32, minHeight: 32, padding: 4, lineHeight: 1 }}
          title={label} aria-label={label} data-direction={direction}
          disabled={disabled || index < 0 || (offset < 0 ? index === 0 : index >= count - 1)}
          onClick={async () => {
            await onMove(index, index + offset);
            keepReorderInView(id, direction);
          }}>
          <FeatherIcon name={`arrow-${direction}`} />
        </button>;
      })}
    </div>
  );
}
